import React, { useEffect, useState } from "react";
import { BASE_URL } from "../env";

const QuizResult = () => {
	const [ResultData, setResultData] = useState([]);
	const [queryType, setQueryType] = useState("");
	const [searchText, setSearchText] = useState("");
	useEffect(() => {
		fetch(BASE_URL + `/getResultById`, {
			method: "GET",
			headers: { "content-type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				setResultData(data.result);
				// console.log(data.result[0].email);
			});
	}, []);

	const searchApi = () => {
		fetch(BASE_URL + `/getResultById?${queryType}=${searchText}`, {
			method: "GET",
			headers: { "content-type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				setResultData(data.result);
			});
	};
	return (
		<>
			<h2 className="text-center py-2 bg-dark text-white">
				Quizz Results
			</h2>
			<div
				className="d-flex justify-content-end align-items-center"
				style={{ width: "40%" }}
			>
				<select
					className={`form-control`}
					aria-label="Default select example"
					name=""
					id=""
					value={queryType}
					onChange={(e) => {
						setQueryType(e.target.value);
						console.log(e.target.value);
					}}
				>
					<option value="undefined">Select Option</option>
					<option value="examId">ExamId</option>
					<option value="email">Email</option>
					<option value="submit_date">Submit Date</option>
				</select>
				<input
					type={
						queryType == "submit_date" ? "datetime-local" : "text"
					}
					placeholder="Put Text"
					id="search_field"
					className="form-control"
					onChange={(e) => {
						setSearchText(e.target.value);
					}}
				/>
				<button
					className="btn btn-dark"
					onClick={() => {
						searchApi();
					}}
				>
					Search
				</button>
			</div>

			<table class="table table-striped">
				<thead>
					<tr>
						<th scope="col" className="text-dark">
							S.No:
						</th>
						<th scope="col" className="text-dark">
							Email
						</th>
						<th scope="col" className="text-dark">
							Exams Attempted
						</th>
						<th scope="col" className="text-dark">
							Submit Date
						</th>
					</tr>
				</thead>
				<tbody>
					{ResultData.map((item, index) => {
						return (
							<>
								<tr>
									<th className="text-dark">{++index}</th>
									<td>{item.email}</td>
									<td>
										{item.examId.examName},{item.examId._id}
									</td>
									<td>{item?.submit_date.slice(0, 10)}</td>
									{/* <td>{item?.submit_date}</td> */}
								</tr>
							</>
						);
					})}
				</tbody>
			</table>
		</>
	);
};

export default QuizResult;
